// extracted by mini-css-extract-plugin
export default {"button":"_0Nh1-Hmlmf","title":"_36usU5mdhA","icon":"_8LYWebixGZ","content":"ryExnrNFkN","expanded":"m79c+LuCvj"};
    if(module.hot) {
      // 1650538028726
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  